import * as CubiqTS from "shared/cubiq-model-multi-asset";

export class OrderPosition {
  constructor(
    public orderId: string,
    public position: CubiqTS.BigNumber,
    public above: boolean,
    public positionUnitId: CubiqTS.PositionUnit,
  ) {}
}
